import { render, staticRenderFns } from "./HowToPage.vue?vue&type=template&id=a673f6da&scoped=true"
import script from "./HowToPage.vue?vue&type=script&lang=js"
export * from "./HowToPage.vue?vue&type=script&lang=js"
import style0 from "./HowToPage.vue?vue&type=style&index=0&id=a673f6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a673f6da",
  null
  
)

export default component.exports